import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../localstorage.service';
import { environment } from 'environments/environment';
@Injectable()
export class DataCollectorService {

    public publicUrls = {
        customFields : `${this.baseUrl}/settings/custom_fields`
    };

    public get baseUrl(): string {
        return `${localStorage.getItem('dc_api_url')}/api`;
    }

    public get serviceUrl(): string {
        return `${localStorage.getItem('dc_api_url')}/service`;
    }
    public baseurl(): string {
        return `${localStorage.getItem('dc_api_url')}/api`;
    }

    public get baseServiceUrl(): string {
        const isProd: boolean = environment.production;
        return isProd ? 'https://apps.zuperpro.com' : `${localStorage.getItem('dc_api_url')}/service/integrations`;
    }

    constructor(private _httpClient: HttpClient) {
    }

    public getData(url, params?): Observable<any> {
        return this._httpClient.get(url, {
            params
        });
    }

    public getEventCount(url, params?): Observable<any> {
        return this._httpClient.get(url, {
            params
        });
    }

    public postData(url, payload, options?): Observable<any> {
        return this._httpClient.post(url, payload, options);
    }
    public postReportData(url: string, payload: any, options?: any): Observable<any> {
        const payloadArray = Array.isArray(payload) ? payload : [payload];
        return this._httpClient.post(url, payloadArray, options);
      }

    public putData(url, payload, options?): Observable<any> {
        return this._httpClient.put(url, payload, options);
    }

    public deleteData(url,params?): Observable<any> {
        return this._httpClient.delete(url, {params});
    }

    public deleteDataPayload(url,payload?): Observable<any> {
        return this._httpClient.delete(url,{body: payload});
    }

    public uploadfile(url, formData): Observable<any> {
        const headers = new HttpHeaders();
        headers.set(
        'Content-Type',
        'multipart/form-data; boundary=----WebKitFormBoundaryIndex----'
        );
        return this._httpClient.post(url, formData,{headers});
    }

    public downloadData(url: string, options: any): Observable<any> {
        return this._httpClient.get(url, options);
    }

    public getBlobContent(url: string,payload): Observable<any> {
        return this.postData(url,payload,{ responseType: 'blob', observe: 'response' });
    }
    
    public getBlobData(url, params?): Observable<any> {
        return this._httpClient.get(url, {
            params,responseType: 'blob'
        });
    }
}
